import { IErrorMonitor } from "../../domain/monitoring/IErrorMonitor";
import { SentryMonitor } from "./SentryMonitor";
import { NoopMonitor } from "./NoopMonitor";

const DSN = process.env.REACT_APP_SENTRY_DSN;
const ENABLED = process.env.REACT_APP_SENTRY_ENABLED === "true";
const ENVIRONMENT = process.env.REACT_APP_NODE_ENV || "development";
const TRACES_SAMPLE_RATE = parseFloat(
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"
);

export class MonitoringFactory {
  static create(): IErrorMonitor {
    if (ENABLED && DSN) {
      return new SentryMonitor(DSN, ENVIRONMENT, TRACES_SAMPLE_RATE);
    }
    return new NoopMonitor();
  }
}
